/* eslint-disable */
import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContainer, ModalRoute } from 'react-router-modal';
import { SERVER_URL } from '../config';
import Notify from './common/notify';
import Header from './common/mobile-header';
import NavigationBar from './common/NavigationBar';
import Static from './common/static';
import AccountContainer from "./operations/account";
import ShiftManagementScheduleContainer from './operations/shifts/ShiftManagementScheduleContainer';
import CreateShiftContainer from './operations/shifts/create/CreateShiftContainer';
import CalendarCreateShiftContainer from './operations/shifts/create/CalendarCreateShiftContainer';
import EditShiftContainer from './operations/shifts/edit/EditShiftContainer';
import CalendarEditShiftContainer from './operations/shifts/edit/CalendarEditShiftContainer';
import { DuplicateShiftContainer } from './operations/shifts/duplicate';
import ClientCheckoutLinkModal from './operations/shifts/ClientCheckoutLinkModal';
import DelegateJobContainer from "./operations/shifts/delegate/DelegateJobContainer";
import CancelShiftContainer from './operations/shifts/cancel/CancelShiftContainer';
import JobsCalendarContainer from './operations/shifts/JobsCalendar';
import FreelancersContainer from './operations/freelancers/index';
import AvailabilityContainer from './operations/availability/index';
import UnallocatedFreelancersContainer from './operations/unallocated-freelancers/index';
import InductionSessionContainer from './operations/induction_session/index';
import ClientsContainer from './operations/clients/index';
import BookingsContainer from './operations/bookings/index';
import NotificationsBox from './operations/notifications/notificationsBox';
import NotificationsContainer from './operations/notifications/index';
import SeriesManagementContainer from './operations/series/index';
import TrackingContainer from './operations/tracking';
import MapContainer from './operations/tracking/mapContainer';
import FreelancerLocationMapContainer from './operations/tracking/freelancerLocation';
import JobContainer from './operations/shifts/job/JobContainer';
import SubscriptionContainer from './operations/shifts/subscriptions/index';
import CreateFreelancersContainer from './operations/freelancers/create';
import UploadFreelancersContainer from './operations/freelancers/upload';
import ClientDetailsContainer from './client-details';
import FreelancerDetails from './freelancer-details/FreelancerDetails';
import SystemSettings from './system-settings/SystemSettings';
import Payroll from './payments/payroll/index';
import PayrollAdmin from './payments/payroll-admin';
import ContactUs from './info/contactUs';
import TimesheetApprovalPage from './timesheets/approval/TimesheetApprovalPage';
import GlobalFreelancersContainer from './operations/global-freelancers';

class Operations extends Component {
    // TODO Clean ups & Use reducers for all of SASS app as
    // I said most of SASS has been coded with deadline feel free to refactor
    // Ps Coded SASS app whilst learning React & ES6
    constructor(props) {
        super(props);
        this.notification = {
            info: this.showInfoMessage.bind(this),
            success: this.showSuccessMessage.bind(this),
            error: this.showErrorMessage.bind(this),
        };
    }

    showInfoMessage(title, message, time = 4200) {
        this.refs.notificator.info(title, message, time);
    }

    showSuccessMessage(title, message, time = 4200) {
        this.refs.notificator.success(title, message, time);
    }

    showErrorMessage(title, message, time = 4200) {
        this.refs.notificator.error(title, message, time);
    }

    render() {
        return (
            <div className="operations-page console">
                <div className="operations-page__inner">
                    <div className="operations-page__header">
                        <Header />
                    </div>
                    <div className="operations-page__row">
                        <div className="operations-page__aside-column">
                            <div className="operations-page__aside-content">
                                <div className="operations-page__logo">
                                    <a>
                                        <img
                                            alt="Logo white"
                                            src="/static/images/logo-white.png"
                                            width="130"
                                            height="40"
                                        />
                                    </a>
                                </div>
                                <div className="navigation-container">
                                    <NavigationBar />
                                </div>
                            </div>
                        </div>
                        <div className="operations-page__content-column">
                            {this.props.notifications.show ? (
                                <NotificationsBox />
                            ) : (
                                ''
                            )}
                            <Notify ref="notificator" />
                            <Route
                                path="/account"
                                render={() => (
                                    <AccountContainer
                                        notification={this.notification}
                                        user={this.props.user}
                                    />
                                )}
                            />
                            <Route
                                path="/jobs/calendar"
                                render={() => (
                                    <JobsCalendarContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                exact={true}
                                path="/jobs/subscriptions/list"
                                component={SubscriptionContainer}
                            />
                            <Route
                                path="/jobs/list"
                                render={() => (
                                    <ShiftManagementScheduleContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                path="/jobs/timesheet-approval"
                                render={() => (
                                    <TimesheetApprovalPage
                                        notification={this.notification}
                                    />
                                )}
                            />
                            <Route
                                path="/series/list"
                                render={() => (
                                    <SeriesManagementContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                path="/clients"
                                component={ClientsContainer}
                            />

                            <ModalRoute
                                exact={true}
                                path="/jobs/list/create"
                                parentPath="/jobs/list"
                                onBackdropClick={() => {}}
                                component={CreateShiftContainer}
                                className="create-shift-modal react-router-modal__modal"
                                props={{ notification: this.notification }}
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/calendar/create"
                                parentPath="/jobs/calendar"
                                onBackdropClick={() => {}}
                                component={CalendarCreateShiftContainer}
                                props={{ notification: this.notification }}
                                className="create-shift-modal react-router-modal__modal"
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/list/cancel/:jobId"
                                parentPath="/jobs/list"
                                component={CancelShiftContainer}
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/list/duplicate/:jobId"
                                parentPath="/jobs/list"
                                component={DuplicateShiftContainer}
                                props={{ notification: this.notification }}
                                className="create-shift-modal react-router-modal__modal"
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/list/check-out-link/:jobId"
                                parentPath="/jobs/list"
                                component={ClientCheckoutLinkModal}
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/list/delegate/:jobId"
                                parentPath="/jobs/list"
                                component={DelegateJobContainer}
                                props={{ notification: this.notification }}
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/list/edit/:jobId"
                                onBackdropClick={() => {}}
                                parentPath="/jobs/list"
                                component={EditShiftContainer}
                                props={{ notification: this.notification }}
                                className="create-shift-modal react-router-modal__modal"
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/calendar/edit/:jobId"
                                onBackdropClick={() => {}}
                                parentPath="/jobs/list"
                                component={CalendarEditShiftContainer}
                                props={{ notification: this.notification }}
                                className="create-shift-modal react-router-modal__modal"
                            />
                            <ModalRoute
                                exact={true}
                                path="/jobs/list/jobdetail/:id"
                                parentPath="/jobs/list"
                                component={JobContainer}
                            />
                            <Route
                                path="/freelancers"
                                render={() => (
                                    <FreelancersContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                path="/global-freelancers"
                                render={() =>
                                    this.props.user?.permissions?.includes(
                                        'auth.view_global_workers_page',
                                    ) ? (
                                        <GlobalFreelancersContainer
                                            notification={this.notification}
                                            {...this.props}
                                        />
                                    ) : (
                                        <Redirect to="/" />
                                    )
                                }
                            />
                            <ModalRoute
                                exact={true}
                                path="/freelancers/upload"
                                parentPath="operations/freelancers"
                                component={UploadFreelancersContainer}
                            />
                            <ModalRoute
                                exact={true}
                                path="/freelancers/create"
                                props={{ notification: this.notification }}
                                parentPath="operations/freelancers"
                                component={CreateFreelancersContainer}
                            />
                            <Route
                                path="/availability-lists"
                                render={() => (
                                    <AvailabilityContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                path="/waiting-room"
                                render={() => (
                                    <UnallocatedFreelancersContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                path="/induction-session-calendar"
                                render={() => (
                                    <InductionSessionContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                            />
                            <Route
                                exact={true}
                                path="/operations/notifications"
                                render={() => (
                                    <NotificationsContainer
                                        notificationBanner={this.notification}
                                        {...this.props}
                                    />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/operations/locationtracking"
                                render={() => (
                                    <TrackingContainer
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/operations/locationtracking/map"
                                component={MapContainer}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/operations/locationtracking/map/:bookingId"
                                component={FreelancerLocationMapContainer}
                                router={this.props.router}
                            />
                            <Switch>
                                <Route
                                    path="/operations/bookings/expanded/:id"
                                    render={() => (
                                        <BookingsContainer
                                            notification={this.notification}
                                            {...this.props}
                                        />
                                    )}
                                    router={this.props.router}
                                />
                                <Route
                                    path="/operations/bookings"
                                    render={() => (
                                        <BookingsContainer
                                            notification={this.notification}
                                            {...this.props}
                                        />
                                    )}
                                    router={this.props.router}
                                />
                            </Switch>
                            <Switch>
                                <Route
                                    path="/payments/payroll-admin"
                                    render={() => (
                                        <PayrollAdmin
                                            notification={this.notification}
                                            {...this.props}
                                        />
                                    )}
                                    router={this.props.router}
                                />
                                <Route
                                    path="/payments/payroll"
                                    render={() => (
                                        <Payroll
                                            notification={this.notification}
                                            {...this.props}
                                        />
                                    )}
                                    router={this.props.router}
                                />
                                <Route
                                    path="/payments/payroll/expanded/:id"
                                    render={() => (
                                        <Payroll
                                            notification={this.notification}
                                            {...this.props}
                                        />
                                    )}
                                    router={this.props.router}
                                />
                            </Switch>
                            <Route
                                path="/operations/client/:id"
                                render={() =>
                                    this.props.user.permissions.includes(
                                        'client.change_client',
                                    ) ? (
                                        <ClientDetailsContainer
                                            clientId={
                                                this.props.match.params.id
                                            }
                                            notification={this.notification}
                                            user={this.props.user}
                                        />
                                    ) : (
                                        <Redirect to="/" />
                                    )
                                }
                                router={this.props.router}
                            />
                            <Route
                                path="/operations/freelancer/:id"
                                render={() => (
                                    <FreelancerDetails
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                path="/operations/settings"
                                render={() => (
                                    <SystemSettings
                                        notification={this.notification}
                                        {...this.props}
                                    />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/refer-client"
                                render={() => (
                                    <Static url="https://referrals.buzzhire.co/" />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/full-time"
                                render={() => (
                                    <Static url="https://temptoperm.pagedemo.co/" />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/manage-multiple-locations"
                                render={() => (
                                    <Static url="https://www.buzzhire.co/manage-multiple-locations" />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/import-your-own-workers"
                                render={() => (
                                    <Static url="https://www.buzzhire.co/import-your-own-workers" />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/knowledge"
                                render={() => (
                                    <Static url="https://www.buzzhire.co/knowledge" />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/hire-full-time-staff"
                                render={() => (
                                    <Static url="https://www.buzzhire.co/hire-full-time-staff" />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/static/guide"
                                render={() => (
                                    <Static url={`${SERVER_URL}/guide/`} />
                                )}
                                router={this.props.router}
                            />
                            <Route
                                exact={true}
                                path="/contact-us"
                                component={ContactUs}
                                router={this.props.router}
                            />
                            <ModalContainer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    user: state.user,
    ...(state.tracking && { notifications: state.notifications }),
})

export default withRouter(connect(mapStateToProps)(Operations));
